import React from 'react'

import { IAiBlackboxProps } from './type'

/**
 * Testing component that accepts IAiBlackboxProps and displays them
 *
 * @param props IAiBlackboxProps - The props to display
 * @returns React component displaying the props in JSON format
 */
const AiBlackboxContentTester: React.FC<IAiBlackboxProps> = (props) => {
  return (
    <div
      style={{
        padding: '20px',
        border: '1px solid #ccc',
        borderRadius: '5px',
        backgroundColor: '#f5f5f5',
        fontFamily: 'monospace',
      }}
    >
      <h3>BlackboxContentTester</h3>
      <div>
        <h4>Props:</h4>
        <pre
          style={{
            backgroundColor: '#fff',
            padding: '10px',
            borderRadius: '4px',
            overflow: 'auto',
            maxHeight: '500px',
          }}
        >
          {JSON.stringify(props, null, 2)}
        </pre>
      </div>
      <div>
        <h4>Individual Properties:</h4>
        <div>
          <strong>startDate:</strong> {props.startDate || 'Not provided'}
        </div>
        <div>
          <strong>endDate:</strong> {props.endDate || 'Not provided'}
        </div>
        <div>
          <strong>queryFilter:</strong>{' '}
          {props.queryFilter ? 'Provided (see JSON above)' : 'Not provided'}
        </div>
      </div>
    </div>
  )
}

export default AiBlackboxContentTester
